import React, { useEffect } from "react";
import { Button } from "reactstrap";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import useGlobal from "store";

const AddCreditCardForm = (props) => {

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    useEffect(() => {
    }, [response]);

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log('submitting form...');
        const {error, paymentMethod} = await stripe.createPaymentMethod({
          type: 'card',
          card: elements.getElement(CardElement),
        });

        console.log('payment method', paymentMethod, error);

        userActions.createUserPaymentMethod(paymentMethod);
    };

    return (<form className="p-3" onSubmit={handleSubmit}>
        <CardElement
            options={{
                style: {
                base: {
                    fontSize: '16px',
                    color: '#424770',
                    '::placeholder': {
                    color: '#aab7c4',
                    },
                },
                invalid: {
                    color: '#9e2146',
                },
                },
            }}
        />
        <div className="pt-3">
            <Button color="primary" className="btn-block" type="submit">Add Payment Method</Button>
        </div>
    </form>);

}
export default AddCreditCardForm;

